import React from "react";


import "./Footer.css";


function Footer(props) {
    return (
        <div className="footer">
           <p>Colab Devs | ViniCode</p>
        </div>
    );
}

export default Footer;